
const UserOrderSlide = ({orderStudyNumber, orderStudyName,orderStudyDate, orderStudyStatus}) =>{

        return(
            <div className="swiper-slide">
                <div className="history-box">
                    <div className="history-title">
                            <h3>{orderStudyNumber}</h3>
                            <div className="swiper-arrows-container">
                                <div  className="swiper-button-next get-start-next-btn get-start-slider-btn red-slider-btn"></div>
                                <div  className="swiper-button-prev get-start-prev-btn get-start-slider-btn red-slider-btn" ></div>
                            </div>
                    </div>
                    <div className="history-details">
                        <div className="history-item">
                            <p className="history-item-title">إسم الدراسة</p>
                            <p className="history-item-info">{orderStudyName}</p>
                        </div>
                        <div className="history-item">
                            <p className="history-item-title">تاريخها</p>
                            <p className="history-item-info">{orderStudyDate}</p>
                        </div>
                        <div className="history-item">
                            <p className="history-item-title">الحالة</p>
                            <p className="history-item-info">{orderStudyStatus}</p>
                        </div>
                    </div>
                </div>
            </div>
                        
            
        );
       
 }
export default UserOrderSlide;


